import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const readError = async (response) => {
  const errorText = await response.text();
  if (!errorText) return "فشل حفظ التغييرات";
  try {
    const parsed = JSON.parse(errorText);
    if (typeof parsed?.message === "string" && parsed.message.trim()) return parsed.message.trim();
  } catch {
    if (errorText.trim() && errorText.length < 400) return errorText.trim();
  }
  return "فشل حفظ التغييرات";
};

const postForm = (url, formData, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", url);
    const token = getToken();
    if (token) xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    xhr.upload.onprogress = (event) => {
      if (!onProgress || !event.lengthComputable) return;
      onProgress(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => {
      let body = {};
      try {
        body = JSON.parse(xhr.responseText || "{}");
      } catch {
        body = {};
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(body);
        return;
      }
      reject(new Error(body.message || "فشل حفظ التغييرات"));
    };
    xhr.onerror = () => reject(new Error("انقطع الاتصال أثناء رفع الصور. حاول مرة أخرى."));
    xhr.onabort = () => reject(new Error("تم إلغاء الرفع."));
    xhr.send(formData);
  });

export const fetchOrderChangeNotes = async (orderId) => {
  const response = await fetch(`${API_BASE_URL}/OrderChangeNotes/${orderId}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchOrderChangeImageBlob = async (orderId, imageId) => {
  const response = await fetch(`${API_BASE_URL}/OrderChangeNotes/${orderId}/images/${imageId}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error("تعذر تحميل الصورة");
  return response.blob();
};

export const saveOrderChange = async ({ orderId, text, files, applyStatus, onProgress }) => {
  const form = new FormData();
  form.append("text", text || "");
  form.append("applyStatus", applyStatus ? "true" : "false");
  (files || []).forEach((file) => form.append("files", file, file.name));
  return postForm(`${API_BASE_URL}/OrderChangeNotes/${orderId}`, form, onProgress);
};

export const addImagesToChangeNote = async ({ orderId, noteId, files, onProgress }) => {
  const form = new FormData();
  (files || []).forEach((file) => form.append("files", file, file.name));
  return postForm(`${API_BASE_URL}/OrderChangeNotes/${orderId}/${noteId}/images`, form, onProgress);
};

export const updateOrderChangeNoteText = async (orderId, noteId, text) => {
  const response = await fetch(`${API_BASE_URL}/OrderChangeNotes/${orderId}/${noteId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({ text }),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const deleteOrderChangeImage = async (orderId, imageId) => {
  const response = await fetch(`${API_BASE_URL}/OrderChangeNotes/${orderId}/images/${imageId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};
